import {asyncActionsFactory} from '@wix/wix-events-commons-statics'
import {MembersPageState, StoreExtraArgs} from '../types/state'

export const createAsyncAction = asyncActionsFactory<MembersPageState, StoreExtraArgs>()
